import React, { useState } from "react";
import image from "../../Assets/images/home/home_take_next_step.png";
import { motion } from "framer-motion";
import CourseTable from "../Course/CourseTable";
import { Link } from "react-router-dom";

const TakeTheNextStep = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const motionVariantsTop = {
        hidden: { opacity: 0, y: -40 },
        visible: { opacity: 1, y: 0 },
    };

    const motionProperties = {
        initial: "hidden",
        whileInView: "visible",
        transition: { duration: 1, delay: 0.5 },
        viewport: { once: true },
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            {isModalOpen && <CourseTable isModalOpen={isModalOpen} closeModal={closeModal} />}
            <div
                className="md:py-40 py-20 md:px-20 px-10 overflow-hidden"
                style={{
                    backgroundImage: `url(${image})`,
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                }}
            >
                <div className="text-center">
                    <motion.h1
                        {...motionProperties}
                        variants={motionVariantsTop}
                        className="md:text-4xl text-xl font-bold tracking-wider text-white "
                    >
                        TAKE THE NEXT STEP WITH Techmentee
                    </motion.h1>
                    <div className="md:mt-20 mt-10 flex md:flex-row flex-col gap-4 justify-center">
                        {/* <button
                            className="lg:px-20 md:px-10 border border-primaryOrangeColor rounded-xl py-2
           text-white uppercase font-medium hover:bg-primaryOrangeColor transition duration-300 ease-linear"
                            onClick={openModal}
                        >
                            Compare Programs
                        </button> */}
                        <Link to="/enrollment" className="lg:px-20 md:px-10 border border-primaryOrangeColor rounded-xl py-2 text-white uppercase font-medium hover:bg-primaryOrangeColor transition duration-300 ease-linear">
                            Get Started
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TakeTheNextStep;
